module.exports = __webpack_public_path__ + "static/media/icon_qr_code 2.278e2fe6.svg";